import FaqRichEditor from './FaqRichEditor';
import { uploadFaqImage } from './faq-service';
import { ensureTiptapContent } from './faq-rich-content';
import type { FaqRichTextFormat } from './types';

interface FaqDiscussionContentProps {
  content?: string | null;
  format?: FaqRichTextFormat | string | null;
  className?: string;
}

export default function FaqDiscussionContent({
  content,
  format,
  className = '',
}: FaqDiscussionContentProps) {
  if (format === 'tiptap') {
    return (
      <div className={`faq-discussion-content text-sm leading-7 text-slate-600 ${className}`}>
        <FaqRichEditor
          content={ensureTiptapContent(content, format)}
          readOnly
          uploadImage={uploadFaqImage}
          minHeight="0px"
        />
      </div>
    );
  }

  return (
    <p className={`whitespace-pre-wrap text-sm leading-7 text-slate-600 ${className}`}>
      {content}
    </p>
  );
}
